import { render, staticRenderFns } from "./RiskLocationAddressForm.vue?vue&type=template&id=2efd849f&"
import script from "./RiskLocationAddressForm.vue?vue&type=script&lang=js&"
export * from "./RiskLocationAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports